// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadingBlock_root__JW5C2","visible":"HeadingBlock_visible__TpH89","positioner":"HeadingBlock_positioner___Wu_T","subTitle":"HeadingBlock_subTitle__X6EPK"};